module.exports = __webpack_public_path__ + "img/full1-min.a40e6156.png";